import { render, staticRenderFns } from "./SupportOpenDocumentationBtn.vue?vue&type=template&id=7107c1da&scoped=true"
import script from "./SupportOpenDocumentationBtn.vue?vue&type=script&lang=js"
export * from "./SupportOpenDocumentationBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7107c1da",
  null
  
)

export default component.exports